import React from 'react';
import { makeStyles } from 'tss-react/mui';
// icons
import DragIcon from '@mui/icons-material/DragIndicator';
const useStyles = makeStyles()({
    dragHandle: {
        cursor: 'grab',
    },
    dragHandleIcon: {
        display: 'inline-block',
        verticalAlign: 'middle',
        pointerEvents: 'none',
    },
});
function TrackLabelDragHandle({ trackId, view, track, }) {
    const { classes } = useStyles();
    return (React.createElement("span", { draggable: true, className: classes.dragHandle, onDragStart: event => {
            const target = event.currentTarget;
            if (target.parentNode) {
                const parent = target.parentNode;
                event.dataTransfer.setDragImage(parent, 20, 20);
                view.setDraggingTrackId(track.id);
            }
        }, onDragEnd: () => view.setDraggingTrackId(undefined), "data-testid": `dragHandle-${view.id}-${trackId}` },
        React.createElement(DragIcon, { className: classes.dragHandleIcon, fontSize: "small" })));
}
export default TrackLabelDragHandle;
